export enum PageTypeEnum {
	SYSTEM_PAGE = 'SYSTEM_PAGE', // 系统页面
	MANEGE_PAGE = 'MANEGE_PAGE', // 后台管理页面
	USER_PAGE = 'USER_PAGE', // 用户页面
	MEMBERINFO = 'MEMBERINFO', //成员界面显示的信息
}
